import isEqual from 'lodash/isEqual';
import { CALL_FORM_STEPS } from '../constants';
import { ICallFormStep } from '../interfaces';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import styles from './callFormSteps.module.scss';

interface IProps {
  scrollToTop: () => void,
  currentStep: ICallFormStep,
  setCurrentStep: (payload: ICallFormStep) => void,
}

const StepNavigationButtons = (
  {
    scrollToTop,
    currentStep,
    setCurrentStep,
  }: IProps,
) => {
  const switchToPreviousStep = () => {
    const steps = Object.values(CALL_FORM_STEPS);
    const currentStepIndex = steps.indexOf(currentStep);
    setCurrentStep(steps[currentStepIndex - 1]);
    scrollToTop();
  };

  return (
    <div className={ styles.buttonsContainer }>
      { !isEqual(currentStep, CALL_FORM_STEPS.YOUR_DETAILS) && (
        <Button
          title="Back"
          type="button"
          variant={ ButtonVariantType.outline }
          dataTest="evercallScheduleYourCallDetailFormBackButton"
          onClick={ switchToPreviousStep }
          className={ styles.stepNavigationBtn }
        />
      ) }
      <Button
        title={ isEqual(currentStep, CALL_FORM_STEPS.ADD_ONS) ? 'Submit' : 'Next' }
        type="submit"
        variant={ ButtonVariantType.action }
        dataTest="evercallScheduleYourCallDetailFormSubmitButton"
        className={ styles.stepNavigationBtn }
      />
    </div>
  );
};

export default StepNavigationButtons;
